"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.onlyHeaderLayoutRequiredServices = void 0;
var _configurationManager = require("@ori/configuration-manager");
const onlyHeaderLayoutRequiredServices = exports.onlyHeaderLayoutRequiredServices = [_configurationManager.serviceSchema.Enum.clientApps, _configurationManager.serviceSchema.Enum.globalApi, _configurationManager.serviceSchema.Enum.identity, _configurationManager.serviceSchema.Enum.mobileOfficeApi, _configurationManager.serviceSchema.Enum.online, _configurationManager.serviceSchema.Enum.staticApi, _configurationManager.serviceSchema.Enum.graphQlNet];
